import { IcomoonIcon } from '@/components/atoms/IcomoonIcon'
import { css } from '@emotion/react'
import { colors, font } from 'plume-ui'
import { StatusPanelSection } from './StatusPanelSection'
import {
  MyLabel,
  MyLabelId,
} from '@/components/pages/companies/reducers/sourcingAnnotationCandidates'
import { MyLabelItem } from '@/components/pages/companies/components/atom/MyLabelItem'
import { useRef, useState } from 'react'
import { MyLabelDropdown } from '@/components/pages/companies/components/tableCell/MyLabelDropdown'
import { useOnClickOutside } from '@/hooks/useOnClickOutside'

type Props = {
  myLabelIds: MyLabelId[]
  myLabels: MyLabel[]
  onSelectMyLabel: (myLabelId: MyLabelId) => void
  onDeselectMyLabel: (myLabelId: MyLabelId) => void
  onRequestEditMyLabelModal: () => void
}

export const MyLabelSection: React.FC<Props> = ({
  myLabelIds,
  myLabels,
  onSelectMyLabel,
  onDeselectMyLabel,
  onRequestEditMyLabelModal,
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const wrapperRef = useRef<HTMLDivElement>(null)
  useOnClickOutside([wrapperRef], () => {
    setIsOpen(false)
  })

  return (
    <StatusPanelSection label="マイラベル">
      <div
        css={css`
          position: relative;
        `}
        ref={wrapperRef}
      >
        <button
          css={css`
            border: none;
            display: flex;
            align-items: center;
            padding: 7px 4px 7px 10px;
            gap: 4px;
            border-radius: 3px;
            cursor: pointer;
            background-color: ${isOpen ? colors.gray40 : 'transparent'};
            &:hover {
              background-color: ${colors.gray40};
            }
            position: relative;
            max-width: 402px; // TODO: ここは決め打ちしたくなく、いい感じに、こう、幅に合わせて伸びたり縮んだりしてほしいよ
          `}
          onClick={() => {
            setIsOpen(!isOpen)
          }}
          data-test-id="my-label"
        >
          {myLabelIds.length === 0 ? (
            <div
              css={css`
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: ${font.weight.normal};
                font-size: 14px;
                color: ${colors.gray70};
              `}
            >
              （空白）
            </div>
          ) : (
            <ul
              css={css`
                padding: 0;
                margin: 0;
                white-space: break-spaces;
                overflow: hidden;
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                gap: 4px;
              `}
            >
              {myLabels
                .filter((it) => myLabelIds.includes(it.id))
                .map((it) => (
                  <MyLabelItem key={it.id} myLabel={it} maxWidth="100%" />
                ))}
            </ul>
          )}
          <IcomoonIcon
            name="arrow1s-down"
            css={css`
              color: ${colors.black30};
              font-size: 20px;
            `}
          />
        </button>
        {isOpen && (
          <MyLabelDropdown
            candidates={myLabels}
            selectedMyLabelIds={myLabelIds}
            onSelectMyLabel={onSelectMyLabel}
            onDeselectMyLabel={onDeselectMyLabel}
            onRequestEditModal={onRequestEditMyLabelModal}
          />
        )}
      </div>
    </StatusPanelSection>
  )
}
